module.exports = __webpack_public_path__ + "img/microphone-close.0b824d63.svg";